export default __webpack_public_path__ + "static/media/MastHead.b3565695.svg";